import CloseAccountModal from './CloseAccountModal';

export { CloseAccountModal };
